module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_intelliquant_m.9dd1e38122384e97d99bf113d83a80c4.png";